module.exports = "<div class=\"layout-column layout-paddingleft\"><div class=\"chatmessage animated fadeIn\" [ngClass]=\"{'text-right': !incoming, 'text-left': incoming}\"><div class=\"content\"><div class=\"layout-row\"><div class=\"flex-nogrow\" *ngIf=\"incoming\"><span class=\"author\">{{ message.name }}: </span></div><div class=\"flex\"><span class=\"timestamp\">{{ message.timestamp | fromNow }}</span></div></div><div class=\"layout-row\"><div class=\"flex\"><span class=\"msg\">{{ message.text }}</span></div></div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/chat-message/chat-message.component.pug
// module id = 1042
// module chunks = 0